import {get} from "../utils";

export default host => type_names =>
  get(`${host}/contentCreators/downloadLink?${type_names ? `&type_names=${type_names.map(type_name => type_name.value + ",")}` : ''}`)
    .then(response => response.text())


